export default "/_next/static/images/img1-17f61ecf944aa851948200b44b947499.png";